import "./style.scss";
import React from "react";
import { Dropdown, Accordion } from "react-bootstrap";
import Apple from "../../assets/images/Apple-appstore.png";
import Logo from "../../assets/images/logo-main-36h.svg";
import Expedia from "../../assets/images/icons/expedia.svg";
import LogoDark from "../../assets/images/icons/logo-main-dark.svg";
import ExpediaDark from "../../assets/images/icons/expedia-logo-dark.svg";
import Android from "../../assets/images/Google-appstore.png";
import SunIcon from "../../assets/images/icons/Sun.svg";
// import CatImage from "../../assets/images/logo-white-bg.svg";
import GlobIcon from "../../assets/images/icons/icons-Globe-Line.svg";
import { getCurrencyBadge } from "../../helpers/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import {
    changeAppCurrency,
    changeAppLocale,
    getLoginConfig,
    setDarkMode,
} from "../../redux/slices/loginconfigSlice";
import AppConfig from "../../helpers/config";
import { faGlobe, faMoon, faSunBright } from "@fortawesome/pro-light-svg-icons";
import { faTiktok } from "@fortawesome/free-brands-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { getAppTranslations } from "../../redux/slices/appTranslationSlice";
import useTranslationCustom from "../../i18n/customHook/useTranslation";

const AppFooter = () => {
    const { T } = useTranslationCustom();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginconfig = useSelector(getLoginConfig);
    const appTranslations = useSelector(getAppTranslations);
    // const [email, setEmail] = useState("");
    const browserLang = navigator.language;
    const browserCountry = browserLang.split('-')[1] || '';

    // const getUrl = (city) =>
    //     `https://city.geniustravel.com/${city}/?languageID=en-GB`;

    // const cities = [
    //     {name: T("Cities:Amsterdam"), link: getUrl("Amsterdam")},
    //     {name: T("Cities:Bali"), link: getUrl("Bali")},
    //     {name: T("Cities:Bangalore"), link: getUrl("Bangalore")},
    //     {name: T("Cities:Bangkok"), link: getUrl("Bangkok")},
    //     {name: T("Cities:Barcelona"), link: getUrl("Barcelona")},
    //     {name: T("Cities:Belgrade"), link: getUrl("Belgrade")},
    //     {name: T("Cities:Berlin"), link: getUrl("Berlin-")},
    //     {name: T("Cities:Bordeaux"), link: getUrl("Bordeaux")},
    //     {name: T("Cities:Brussels"), link: getUrl("Brussels")},
    //     {name: T("Cities:Delhi"), link: getUrl("Delhi")},
    //     {name: T("Cities:Dubai"), link: getUrl("Dubai")},
    //     {name: T("Cities:Edinburgh"), link: getUrl("Edinburgh")},
    //     {name: T("Cities:Geneva"), link: getUrl("Geneva")},
    //     {name: T("Cities:Goa"), link: getUrl("Goa")},
    //     {name: T("Cities:Ibiza"), link: getUrl("Ibiza")},
    //     {name: T("Cities:Jerusalem"), link: getUrl("Jerusalem")},
    //     {name: T("Cities:Lisbon"), link: getUrl("Lisbon")},
    //     {name: T("Cities:London"), link: getUrl("London")},
    //     {name: T("Cities:Monaco"), link: getUrl("Monaco")},
    //     {name: T("Cities:Mumbai"), link: getUrl("Mumbai")},
    //     {name: T("Cities:New_York"), link: getUrl("New-York")},
    //     {name: T("Cities:Paris"), link: getUrl("Paris")},
    //     {name: T("Cities:Phuket"), link: getUrl("Phuket")},
    //     {name: T("Cities:Rajasthan"), link: getUrl("Rajasthan")},
    //     {name: T("Cities:Rome"), link: getUrl("Rome")},
    //     {name: T("Cities:San_Francisco"), link: getUrl("San-Francisco")},
    //     {name: T("Cities:Venice"), link: getUrl("Venice")},
    // ];

    return (
        <footer id="footer" className="footer-wrapper">
            <div className="footer-top">
                <div className="container">
                    {/* <img src={CatImage} className="cat-icon" alt={"cat-icon"}/> */}
                    <div className="row for-desktop hide-on-tab">
                        {/*<h6*/}
                        {/*    className="fs-16 gray-text bold footer-title"*/}
                        {/*    style={{marginBottom: "2rem"}}*/}
                        {/*>*/}
                        {/*    {T('Filters:Footer_City_Trip')}*/}
                        {/*</h6>*/}
                        {/*<div className="col-md-3 for-desktop">*/}
                        {/*    <div className="footer-items">*/}
                        {/*        <ul className="link-items">*/}
                        {/*            {cities.slice(0, 7).map((city, index) => {*/}
                        {/*                return (*/}
                        {/*                    <li key={index + city}>*/}
                        {/*                        <a*/}
                        {/*                            className="gray-text"*/}
                        {/*                            href={city.link}*/}
                        {/*                            target="_blank"*/}
                        {/*                            rel="noopener noreferrer"*/}
                        {/*                        >*/}
                        {/*                            {city?.name}*/}
                        {/*                        </a>*/}
                        {/*                    </li>*/}
                        {/*                );*/}
                        {/*            })}*/}
                        {/*        </ul>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="col-md-3 for-desktop">*/}
                        {/*    <div className="footer-items">*/}
                        {/*        <ul className="link-items">*/}
                        {/*            {cities.slice(7, 14).map((city, index) => {*/}
                        {/*                return (*/}
                        {/*                    <li key={index + city}>*/}
                        {/*                        <a*/}
                        {/*                            className="gray-text"*/}
                        {/*                            href={city.link}*/}
                        {/*                            target="_blank"*/}
                        {/*                            rel="noopener noreferrer"*/}
                        {/*                        >*/}
                        {/*                            {city?.name}*/}
                        {/*                        </a>*/}
                        {/*                    </li>*/}
                        {/*                );*/}
                        {/*            })}*/}
                        {/*        </ul>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="col-md-3 for-desktop">*/}
                        {/*    <div className="footer-items">*/}
                        {/*        <ul className="link-items">*/}
                        {/*            {cities.slice(14, 21).map((city, index) => {*/}
                        {/*                return (*/}
                        {/*                    <li key={index + city}>*/}
                        {/*                        <a*/}
                        {/*                            className="gray-text"*/}
                        {/*                            href={city?.link}*/}
                        {/*                            target="_blank"*/}
                        {/*                            rel="noopener noreferrer"*/}
                        {/*                        >*/}
                        {/*                            {city?.name}*/}
                        {/*                        </a>*/}
                        {/*                    </li>*/}
                        {/*                );*/}
                        {/*            })}*/}
                        {/*        </ul>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="col-md-3 for-desktop">*/}
                        {/*    <div className="footer-items">*/}
                        {/*        <ul className="link-items">*/}
                        {/*            {cities.slice(21, cities.length).map((city, index) => {*/}
                        {/*                return (*/}
                        {/*                    <li key={index + city}>*/}
                        {/*                        <a*/}
                        {/*                            className="gray-text"*/}
                        {/*                            href={city.link}*/}
                        {/*                            target="_blank"*/}
                        {/*                            rel="noopener noreferrer"*/}
                        {/*                        >*/}
                        {/*                            {city?.name}*/}
                        {/*                        </a>*/}
                        {/*                    </li>*/}
                        {/*                );*/}
                        {/*            })}*/}
                        {/*        </ul>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="col-12 for-mobile">*/}
                        {/*    <div className="footer-items">*/}
                        {/*        <div className="footer-dropdown">*/}
                        {/*            <Dropdown>*/}
                        {/*                <Dropdown.Toggle>New York</Dropdown.Toggle>*/}
                        {/*                <Dropdown.Menu>*/}
                        {/*                    {cities.map((city, index) => (*/}
                        {/*                        <Dropdown.Item*/}
                        {/*                            key={index + city}*/}
                        {/*                            onClick={() => window.open(city?.link, "_blank")}*/}
                        {/*                        >*/}
                        {/*                            {city?.name}*/}
                        {/*                        </Dropdown.Item>*/}
                        {/*                    ))}*/}
                        {/*                </Dropdown.Menu>*/}
                        {/*            </Dropdown>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="col-md-3 col-6">
                            <div className="footer-items">
                                <h6 className="fs-16 gray-text bold footer-title">
                                    {T("Filters:Footer_Contact")}
                                </h6>
                                <ul className="link-items">
                                    <li>
                                        <a
                                            className="gray-text"
                                            onClick={() => window.open(`mailto:travel@geniustravel.com`)}
                                        >
                                            {T("Filters:Footer_Contact")}
                                        </a>
                                    </li>
                                    <li>
                                        <Link className="gray-text" to="/faqs">
                                            {T("Filters:Footer_Faq")}
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="footer-items">
                                <h6 className="fs-16 gray-text bold footer-title">Genius®</h6>
                                <ul className="link-items">
                                    <li>
                                        <a
                                            className="gray-text"
                                            onClick={() =>
                                                navigate('/about-us')
                                            }
                                        >
                                            {T("Filters:Footer_About_Us")}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="gray-text"
                                            onClick={() =>
                                                navigate('/press')
                                            }
                                        >
                                            {T("Filters:Footer_Press")}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="gray-text"
                                            onClick={() =>
                                                navigate('/vacancies')
                                            }
                                        >
                                            {T("Filters:Footer_Vacancies")}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="footer-items">
                                <h6 className="fs-16 gray-text bold footer-title">
                                    {T("Filters:Footer_Download_App")}
                                </h6>
                                <div className="app-actions">
                                    <a
                                        href={AppConfig.AndroidPlayStoreLink}
                                        target={"_blank"}
                                        rel="noopener noreferrer"
                                    >
                                        <img src={Android} alt={"android-picture"} />
                                    </a>
                                    <a
                                        href={AppConfig.iOSAppStoreLink}
                                        target={"_blank"}
                                        rel="noopener noreferrer"
                                    >
                                        <img src={Apple} alt={"apple-picture"} />
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-lg-3 col-md-12 col-12">
                            <div className="footer-items">
                                <h6 className="fs-16 gray-text bold footer-title">
                                    {T("Filters:Footer_Email_Heading")}
                                </h6>
                                <form
                                    className="newsletter"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        window.open(
                                            `mailto:${email}?subject=News Letter Subscriber`
                                        );
                                    }}
                                >
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder={T("Filters:Footer_Email_Placeholder")}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required={true}
                                    />
                                    <button type="submit">{T("Buttons:Send")}</button>
                                </form>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="footer-middle">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="powered-by-text">
                                <img
                                    src={loginconfig.darkMode ? Logo : LogoDark}
                                    alt={"logo"}
                                    style={{ width: "86px" }}
                                />{" "}
                                <div>
                                    {T("Filters:Footer_Powered_By")}{" "}
                                    <img
                                        src={loginconfig.darkMode ? Expedia : ExpediaDark}
                                        alt={"expedia"}
                                    />
                                </div>
                                <a className="tiktok-btn" href="https://www.tiktok.com/@genius.app?_r=1&_t=ZG-94A3hJyCdPs" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faTiktok} />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-5 col-12 hide-on-tab">
                            <div className="footer-action">
                                <ul>
                                    <li>
                                        <button
                                            className="action-btn dropdown-toggle"
                                            onClick={() =>
                                                dispatch(setDarkMode(!loginconfig.darkMode))
                                            }
                                        >
                                            {loginconfig.darkMode ? (
                                                <FontAwesomeIcon icon={faSunBright} />
                                            ) : (
                                                <FontAwesomeIcon icon={faMoon} />
                                            )}
                                            {loginconfig.darkMode ? T("Home:Home_Light_Mode") : T("Home:Home_Dark_Mode")}
                                        </button>
                                    </li>
                                    <li>
                                        <Dropdown>
                                            <Dropdown.Toggle>
                                                <FontAwesomeIcon icon={faGlobe} />
                                                {loginconfig?.locale?.country}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <h6>{T("Home:Home_Language")}</h6>
                                                {appTranslations?.locales?.map((language, index) => {
                                                    return (
                                                        <Dropdown.Item
                                                            key={index}
                                                            onClick={() =>
                                                                dispatch(changeAppLocale(language))
                                                            }
                                                            active={language?.id === loginconfig?.locale?.id}
                                                        >
                                                            {language?.country}
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </li>
                                    <li>
                                        <Dropdown>
                                            <Dropdown.Toggle>
                                                <span style={{ color: "#BDC6D7" }}>
                                                    {getCurrencyBadge(loginconfig?.currency?.code)}
                                                </span>{" "}
                                                {loginconfig?.currency?.code}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <h6>{T("Home:Home_Currency")}</h6>
                                                {AppConfig.currencies.map((currency, index) => {
                                                    return (
                                                        <Dropdown.Item
                                                            key={index}
                                                            onClick={() => dispatch(changeAppCurrency(currency))}
                                                            active={currency?.code === loginconfig?.currency?.code}
                                                        >
                                                            {`${currency?.symbol} ${currency?.name?.toUpperCase()}`}
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-5 col-12 for-desktop hide-on-tab">
                            <div className="footer-dropdown">
                                <Dropdown>
                                    <Dropdown.Toggle>{T("Home:Home_Settings")}</Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() =>
                                                dispatch(setDarkMode(!loginconfig.darkMode))
                                            }
                                        >
                                            {loginconfig.darkMode ? (
                                                <img src={SunIcon} className="icon" alt={"sun-icon"} />
                                            ) : (
                                                <FontAwesomeIcon icon={faMoon} />
                                            )}
                                            {loginconfig.darkMode ? T("Home:Home_Light_Mode") : T("Home:Home_Dark_Mode")}
                                        </Dropdown.Item>
                                        <Accordion className="dropdown-accordion">
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>
                                                    <img
                                                        src={GlobIcon}
                                                        className="icon"
                                                        alt={"globe-icon"}
                                                    />
                                                    {loginconfig?.locale?.country}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>{T("Home:Home_Language")}</h6>
                                                    {appTranslations?.locales?.map((language, index) => {
                                                        return (
                                                            <Dropdown.Item
                                                                key={index}
                                                                onClick={() =>
                                                                    dispatch(changeAppLocale(language))
                                                                }
                                                                active={language?.id === loginconfig?.locale?.id}
                                                            >
                                                                {language?.country}
                                                            </Dropdown.Item>
                                                        );
                                                    })}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header>
                                                    <span style={{ color: "#BDC6D7", marginRight: "5px" }}>
                                                        {getCurrencyBadge(
                                                            loginconfig?.currency?.code
                                                        )}
                                                    </span>
                                                    {loginconfig?.currency?.code}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>{T("Home:Home_Currency")}</h6>
                                                    {AppConfig.currencies.map((currency, index) => {
                                                        return (
                                                            <Dropdown.Item
                                                                key={index}
                                                                onClick={() => dispatch(changeAppCurrency(currency))}
                                                                active={currency?.code === loginconfig?.currency?.code}
                                                            >
                                                                {`${currency?.symbol} ${currency?.name?.toUpperCase()}`}
                                                            </Dropdown.Item>
                                                        );
                                                    })}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom hide-on-small-screen">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-sm-9">
                            <ul className="static-pages-link">
                                <li>
                                    <a>
                                        {T("Filters:Footer_Copyright")} © {new Date().getFullYear()}{" "}
                                        Genius®
                                    </a>
                                </li>
                                <li>
                                    <a onClick={() => navigate(`/privacy-policy/query?locale=${loginconfig?.locale?.code}&external=false`)}>
                                        {T("Filters:Footer_Privacy_Policy")}
                                    </a>
                                </li>
                                <li>
                                    <a onClick={() => {
                                        if (browserCountry === 'GB' || loginconfig?.locale?.code === 'en_GB') {
                                            window.open("https://www.expedia.com/lp/b/terms-of-service?currency=USD&siteid=1", "_blank");
                                        } else {
                                            navigate(`/terms-conditions`);
                                        }
                                    }}>
                                        {T("Filters:Footer_Terms_Conditions")}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <ul className="social-links">
                                <li>
                                    <a className="" href="https://www.tiktok.com/@genius.app?_r=1&_t=ZG-94A3hJyCdPs" target="_blank" rel="noopener noreferrer">
                                        <FontAwesomeIcon icon={faTiktok} />
                                    </a>
                                </li>
                                {/* <li>
                                    <a>
                                        <FontAwesomeIcon icon={faFacebookF} />
                                    </a>
                                </li>
                                <li>
                                    <a>
                                        <FontAwesomeIcon icon={faInstagram} />
                                    </a>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default AppFooter;
